import AddressBookView from './address-book-view'

export default AddressBookView
